import React from 'react'
import { Props as FormFieldProps } from 'components/atoms/FormField/FormField'
import {
  FormField,
  FormText,
  FormPassword,
  FormSelect,
  FormTextarea,
  FormCheckbox,
  FormRadio,
  // FormDate,
  // FormToggle,
  // FormFile,
} from 'components/atoms'
import { setRecaptchaRequired } from 'containers/pagina'
import { useDispatch, useSelector } from 'react-redux'

export type FormikFieldProps = {
  id?: string
  label?: string
  placeholder?: string
  type?:
    | 'text'
    | 'email'
    | 'number'
    | 'password'
    | 'select'
    | 'textarea'
    | 'checkbox'
    | 'radio'
    | 'file'
    | 'date'
    | 'toggle'
  name: string
  required?: boolean
  readOnly?: boolean
  disabled?: boolean
  layout?: 'sm' | 'md' | 'lg' | 'full'
  space?: 'none' | 'md'
  options?: any[]
  min?: number
  max?: number
  minDate?: string
  maxDate?: string
  step?: number | string
  unitaMisura?: string
  unitaMisuraPos?: 'left' | 'right'
  helper?: any
  togglePassword?: boolean
  icon?: React.ReactNode
  variant?: '' | 'yesno' | 'buttons' | 'questionario'
  showErrors?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onRemove?: (e: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
  isSearchable?: boolean
  loadRecaptchaOnChange?: boolean
}

const FormikField = (props: FormikFieldProps & { formik: any }) => {
  const {
    id = '',
    label = undefined,
    placeholder = undefined,
    name = '',
    required = undefined,
    readOnly = undefined,
    disabled = undefined,
    layout = undefined,
    space = undefined,
    formik = {},
    type = 'text',
    togglePassword = undefined,
    options = [],
    min = undefined,
    max = undefined,
    minDate = undefined,
    maxDate = undefined,
    step = undefined,
    helper = undefined,
    icon = undefined,
    variant = undefined,
    showErrors = false,
    onChange = undefined,
    onRemove = undefined,
    className = '',
    loadRecaptchaOnChange = false,
    isSearchable = undefined,
  } = props

  const { recaptchaRequired } = useSelector((state: any) => state?.pagina)
  const dispatch = useDispatch()

  const recaptchaOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (loadRecaptchaOnChange && !recaptchaRequired) {
      dispatch(setRecaptchaRequired())
    }

    return type === 'select'
      ? onChange
        ? onChange(fixBooleanOptions(e))
        : formik?.handleChange(fixBooleanOptions(e))
      : onChange
      ? onChange(e)
      : formik?.handleChange(e)
  }

  const componentsMap = {
    text: FormText,
    email: FormText,
    number: FormText,
    password: FormPassword,
    select: FormSelect,
    textarea: FormTextarea,
    checkbox: FormCheckbox,
    radio: FormRadio,
    // file: FormFile,
    // date: FormDate,
    // toggle: FormToggle,
  }

  const formFieldProps: FormFieldProps = {
    id: id,
    label: type === 'checkbox' ? undefined : label,
    required: required,
    layout: layout,
    space: space,
    className: className,
  }

  // per gestire valori booleani in "select"
  const getSelectValue = (value) => {
    return value !== null && value !== undefined ? value.toString() : value
  }

  // per gestire valori booleani in "select"
  const fixBooleanOptions = (e) => {
    if (e.target.value === 'true') e.target.value = true
    if (e.target.value === 'false') e.target.value = false
    return e
  }

  const formElementProps = {
    id: id,
    name: name,
    label: type === 'checkbox' ? label : undefined,
    placeholder: placeholder,
    readOnly: readOnly,
    required: required,
    disabled: disabled,
    checked: formik?.values?.[name],
    value: type === 'select' ? getSelectValue(formik?.values?.[name]) : formik?.values?.[name],
    files: type === 'file' ? formik?.values?.[name] : undefined,
    onBlur: formik?.handleBlur(name),
    onChange: recaptchaOnChange,
    onRemove: onRemove,
    options: type === 'select' || type === 'radio' ? options : undefined,
    togglePassword: type === 'password' ? togglePassword : undefined,
    type: type === 'text' || type === 'email' || type === 'number' ? type : undefined,
    min: type === 'number' ? min : undefined,
    max: type === 'number' ? max : undefined,
    minDate,
    maxDate,
    step: type === 'number' ? step : undefined,
    helper: type === 'toggle' ? helper : undefined,
    icon: type === 'toggle' ? icon : undefined,
    variant: ['toggle', 'radio'].includes(type) ? variant : undefined,
    status: showErrors ? (formik?.errors?.[name] ? 'error' : 'success') : '',
    errorMessage: formik?.errors?.[name],
    isSearchable: type === 'select' ? isSearchable : undefined,
  }

  const FormComponent = componentsMap[type]

  return (
    <FormField {...formFieldProps}>
      <FormComponent {...formElementProps} />
    </FormField>
  )
}

export default FormikField
